import React, {useState, useRef, useEffect} from 'react';
import styles from './MediaPopup.module.css';

const MediaPopup = ({isOpen, type, src, onClose, name, description, thumbnail}) => {
    if (!isOpen) return null;

    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    // Tự động play video khi mở modal
    useEffect(() => {
        setIsPlaying(false);
        if (isOpen && type === 'video' && videoRef.current) {
            const playVideo = () => {
                videoRef.current.play().catch(err => {
                    console.log('Auto-play was prevented:', err);
                });
            };
            setTimeout(playVideo, 200);
        }
    }, [isOpen, src, type]);

    // Toggle play/pause video
    const togglePlay = e => {
        e.stopPropagation();
        const v = videoRef.current;
        if (!v) return;
        if (v.paused) {
            v.play();
            setIsPlaying(true);
        } else {
            v.pause();
            setIsPlaying(false);
        }
    };

    return (
        <div className={styles['media-popup']} onClick={onClose} role="dialog" aria-modal="true">
            <div
                className={type === 'image' ? styles['image-popup__content'] : styles['video-popup__content']}
                onClick={e => e.stopPropagation()}>
                <button className={styles['media-popup__close']} onClick={onClose} aria-label="Close">
                    <img src="/bw_image/close-2.svg" alt="" aria-hidden="true" />
                </button>

                {src && (name || description) && (
                    <div className={styles['media-popup__info']}>
                        {name && <h3 className={styles['media-popup__name']}>{name}</h3>}
                        {description && <p className={styles['media-popup__description']}>{description}</p>}
                    </div>
                )}

                {src ? (
                    type === 'image' ? (
                        <img src={src} alt="popup" className={styles['media-popup__image']} />
                    ) : (
                        <div
                            className={styles['media-popup__video-wrapper']}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}>
                                    <video
                                        ref={videoRef}
                                        src={src}
                                        playsInline
                                        poster={thumbnail || undefined}
                                        className={styles['media-popup__video']}
                                        onClick={togglePlay}
                                        onPlay={() => setIsPlaying(true)}
                                        onPause={() => setIsPlaying(false)}
                                    />
                            {(!isPlaying || isHovered) && (
                                <button
                                    type="button"
                                    className={styles['media-popup__play-btn']}
                                    onClick={togglePlay}
                                    aria-label={isPlaying ? 'Pause video' : 'Play video'}>
                                    {isPlaying ? (
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                            <circle cx="32" cy="32" r="32" fill="#006940" />
                                            <rect x="24" y="18" width="6" height="28" fill="#fff" />
                                            <rect x="34" y="18" width="6" height="28" fill="#fff" />
                                        </svg>
                                    ) : (
                                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                            <circle cx="32" cy="32" r="32" fill="#006940" />
                                            <polygon points="26,20 46,32 26,44" fill="#fff" />
                                        </svg>
                                    )}
                                </button>
                            )}
                        </div>
                    )
                ) : (
                    <div className={styles['media-popup__no-media']}>
                        <div className={styles['no-media-content']}>
                            <div className={styles['no-media-icon']}>
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#006940"/>
                                </svg>
                            </div>
                            <h3 className={styles['no-media-title']}>Cảm nhận của khách hàng</h3>
                            <div className={styles['full-comment-content']}>
                                {name && <h4 className={styles['full-comment-name']}>{name}</h4>}
                                {description && (
                                    <p className={styles['full-comment-description']}>
                                        "{description}"
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MediaPopup;
